import React, { useState, useEffect, useMemo } from 'react';
import TR from './../../Trans';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { checkIfMobile } from '../../services/screen';
import { Views } from './../../enums/enums';
import IconButton from '@mui/material/IconButton';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import IntervalService from './../../services/intervals';
import PerformancePeekListItem from '../items/PerformancePeekListItem';
import muvikaAttrs from './../../attrs';
import MuvikaService from './../../services/muvika';
import Collapse from '@mui/material/Collapse';
import { useMediaQuery } from 'react-responsive';
import List from '@mui/material/List';
import EditPlayListPerformance from '../dialogs/EditPlayListPerformance';
import EditIcon from '@mui/icons-material/Edit';
import dayjs from 'dayjs';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ChangeTrackPerformance from '../dialogs/ChangeTrackPerformance';
import settingsStore from '../../stores/settings';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import accountStore from '../../stores/account';
import performanceStore from '../../stores/performance';
import playerStore from '../../stores/player';
import messageStore from './../../stores/message';
import favoritesStore from '../../stores/favorites';
import navigationStore from '../../stores/navigation';

function PlayListListItem(props) {

  const [open, setOpen] = useState(props.open);
  const [isEditPerformanceOpen, setIsEditPerformanceOpen] = useState(false);
  const [chosenPerformance, setChosenPerformance] = useState(null);
  const [isChangeTrackPerformanceOpen, setIsChangeTrackPerformanceOpen] = useState(false);
  const [chosenTrack, setChosenTrack] = useState({});

  const addPerformanceToPlayQueue = performanceStore((state) => state.addPerformanceToPlayQueue);
  const addPerformanceToPlayList = performanceStore((state) => state.addPerformanceToPlayList);
  const setIsPlaying = playerStore((state) => state.setIsPlaying);
  const setIsStopped = playerStore((state) => state.setIsStopped);
  const setError = messageStore((state) => state.setError);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isPlaying = playerStore((state) => state.isPlaying);
  const playLists = performanceStore((state) => state.playLists);
  const singers = singersStore((state) => state.singers);
  const setIsAutoPlayOn = playerStore((state) => state.setIsAutoPlayOn);
  const setIsSwitching = playerStore((state) => state.setIsSwitching);
  const editPerformanceInPlayList = performanceStore((state) => state.editPerformanceInPlayList);
  const movePerformanceInPlayList = performanceStore((state) => state.movePerformanceInPlayList);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const changeTrackPerformance = performanceStore((state) => state.changeTrackPerformance);
  const timeDiff = accountStore((state) => state.timeDiff);
  const playQueue = performanceStore((state) => state.playQueue);
  const setMobilePlayerVisible = navigationStore((state) => state.setMobilePlayerVisible);
  const goToView = navigationStore((state) => state.goToView);
  const settingsAutoPlayEnabled = settingsStore((state) => state.settings?.autoplay_enabled);
  const settingsUsageMode = settingsStore((state) => state.settings?.usage_mode);

  const [isPlayingNow, setPlayingNow] = useState(false);

  const handleOpenEditPerformance = (performance, playNow = false) => {
    if (performance) {
      console.log("isPlayingNow", playNow);
      setPlayingNow(playNow);
      performance.track.last_singer_id = performance.profile.id;
      setChosenPerformance(performance);
      setIsEditPerformanceOpen(true);
      props.onEditPerformanceClose();
    }
  };

  const handleCloseEditPerformance = () => {
    setIsEditPerformanceOpen(false);
    props.onEditPerformanceClose();
  };

  const handleOpenChangePerformance = (track) => {
    if (performanceToBeChanged) {
      MuvikaService.getLastPerformance(sessionToken, track.track_id)
        .then(function (res) {
          if (res.data.error) {
            setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
          } else {
            if (res.data.data.profile_id) {
              track.last_pitch = res.data.data.pitch;
            }
            track.last_singer_id = performanceToBeChanged.profile.id;
            setChosenTrack(track);
            setIsChangeTrackPerformanceOpen(true);
          }
        })
        .catch(function () { });
    }
  };

  const handleChangeTrackPerformance = (singerProfile, pitch) => {
    if (singerProfile && (pitch >= -3 && pitch <= 3)) {
      changeTrackPerformance(sessionToken, chosenTrack, singerProfile, pitch);
      setIsChangeTrackPerformanceOpen(false);
      props.onEditPerformanceClose();
    } else {
      setError(sessionToken, 0, TR.cm_select_singer);
    }
  };

  const handleCloseChangeTrackPerformance = () => {
    setIsChangeTrackPerformanceOpen(false);
    props.onEditPerformanceClose();
  };

  const isMobile = useMediaQuery({ query: '(max-width: 720px)' });

  const handleEditPerformance = (performanceId, singerProfile, pitch, playList, toPos, isManual, playNow = false, isSongbookQueue = false) => {
    if (playList) {
      if (playList.id === props.playList.id) {
        editPerformanceInPlayList(sessionToken, performanceId, singerProfile, pitch, playList.id, toPos);
        setIsEditPerformanceOpen(false);
      } else {
        addPerformanceToPlayList(sessionToken, chosenPerformance.track, singerProfile, pitch, playList.id, toPos);
        setIsEditPerformanceOpen(false);
      }
    } else {
      if (isSongbookQueue) {
        MuvikaService.createSongRequest(sessionToken, "add", chosenPerformance.track.track_id, singerProfile.id, pitch, [])
          .then(function (res) {
            if (res.data.error) {
              setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            }
          })
          .catch(function () { });
        setIsEditPerformanceOpen(false);
      } else {
        setIsAutoPlayOn(settingsAutoPlayEnabled);
        addPerformanceToPlayQueue(sessionToken, chosenPerformance.track, singerProfile, pitch, toPos, isManual, playNow);
        if (toPos == 0 && playNow) {
          IntervalService.clearAllIntervals();
          setIsAutoPlayOn(false);
          setIsSwitching(true);
          let isMobile = checkIfMobile();
          if (isMobile) {
            goToView(Views.Blank);
            setMobilePlayerVisible(true);
          }
        }
        setIsEditPerformanceOpen(false);
      }
    }
    props.onEditPerformanceClose();
    /*     if (singerProfile && (pitch >= -3 && pitch <= 3)) {
          if (toPos == 0) {
            setIsAutoPlayOn(settings.autoplay_enabled);
            addPerformanceToPlayQueue(sessionToken, chosenPerformance.track, singerProfile, pitch, toPos, isManual);
            setIsEditPerformanceOpen(false);
            IntervalService.clearAllIntervals();
            setIsAutoPlayOn(false);
            if(!checkIfMobile()) {
              setIsSwitching(true);
              setIsPlaying(true);
              setIsStopped(false);
            } else {
              setIsPlaying(false);
              setIsStopped(true);
            }
          } else if (toPos == 1) {
            setIsAutoPlayOn(settings.autoplay_enabled);
            addPerformanceToPlayQueue(sessionToken, chosenPerformance.track, singerProfile, pitch, toPos, isManual);
            setIsEditPerformanceOpen(false);
          } else {
            if (playList) {
              if (playList.id === props.playList.id) {
                editPerformanceInPlayList(sessionToken, performanceId, singerProfile, pitch, playList.id);
                setIsEditPerformanceOpen(false);
              } else {
                addPerformanceToPlayList(sessionToken, chosenPerformance.track, singerProfile, pitch, playList.id);
                setIsEditPerformanceOpen(false);
              }
            } else {
              setIsAutoPlayOn(settings.autoplay_enabled);
              addPerformanceToPlayQueue(sessionToken, chosenPerformance.track, singerProfile, pitch, toPos, isManual);
              setIsEditPerformanceOpen(false);
            }
          }
        } else {
          setError(sessionToken, 0, TR.cm_select_singer);
        } */
  };

  const handleClick = (e) => {
    e.stopPropagation();
    let openPlayListsJSON = sessionStorage.getItem(muvikaAttrs.service + "-playlists-opened") || "[]";
    let openPlayLists = JSON.parse(openPlayListsJSON);
    if (!open) {
      openPlayLists.push(props.playList.id);
      sessionStorage.setItem(muvikaAttrs.service + "-playlists-opened", JSON.stringify(openPlayLists));
    } else {
      const index = openPlayLists.indexOf(props.playList.id);
      if (index > -1) {
        openPlayLists.splice(index, 1);
      }
      sessionStorage.setItem(muvikaAttrs.service + "-playlists-opened", JSON.stringify(openPlayLists));
    }
    setOpen(!open);
  };

  const renderEditButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => props.onOpenEditDialog(e)}>
      <EditIcon />
    </IconButton>;
  };

  const renderPlayButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => props.onSetCurrentPlayList(e)}>
      <PlayArrowIcon />
    </IconButton>;
  };

  const renderDeleteButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => props.onOpenDeleteDialog(e)}>
      <DeleteIcon />
    </IconButton>;
  };

  const buttons = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        if (props.type === "normal") {
          return <div>
            {renderPlayButton()}
            {renderEditButton()}
            {renderDeleteButton()}
          </div>;
        }
      }
    } else {
      if (props.type === "normal") {
        return <div>
          {renderPlayButton()}
          {renderEditButton()}
          {renderDeleteButton()}
        </div>;
      }
    }
  };

  const handleDragEnd = (result) => {
    //console.log("drag end")
    if (result.destination) {
      let source = result.source.index;
      let dest = result.destination.index;
      if (source != dest) {
        movePerformanceInPlayList(sessionToken, props.playList.id, source, dest);
      }
    }
  };

  const performanceIds = useMemo(() => {
    return props.playList?.items?.map((p) => p.unique_id);
  }, [props.playList]);

  const performances = useMemo(() => {
    if (performanceIds) {
      if (performanceIds.length > 0) {
        console.log("render again");
        return performanceIds.map((performanceId, index) => {
          return <PerformancePeekListItem
            key={performanceId}
            draggableId={"playlist-" + props.id + "-" + performanceId}
            index={index}
            count={performanceIds.length}
            playListId={props.id}
            performanceId={performanceId}
            onMenuClose={() => {
              props.onEditPerformanceClose();
            }}
            onPlayNow={(performance) => {
              handleOpenEditPerformance(performance, true);
            }}
            onEditPerformance={(e, performance) => {
              handleOpenEditPerformance(performance);
            }}
            onChangeTrackPerformance={(e, performance) => {
              e.preventDefault();
              handleOpenChangePerformance(performance.track);
            }}
          />;
        });
      }
    }
    return <span>{TR.cm_playlist_is_empty}</span>;
  }, [performanceIds]);

  const performancesNonDraggable = useMemo(() => {
    if (performanceIds) {
      if (performanceIds.length > 0) {
        console.log("render again");
        return performanceIds.map((performanceId, index) => {
          return <PerformancePeekListItem
            key={performanceId}
            draggableId={"playlist-" + props.id + "-" + performanceId}
            index={index}
            count={performanceIds.length}
            playListId={props.id}
            performanceId={performanceId}
            onMenuClose={() => {
              props.onEditPerformanceClose();
            }}
            onPlayNow={() => {
              handleOpenEditPerformance(performance, true);
            }}
            onEditPerformance={() => {
              handleOpenEditPerformance(performance);
            }}
            onChangeTrackPerformance={(e) => {
              e.preventDefault();
              handleOpenChangePerformance(performance.track);
            }}
          />;
        });
      }
    }
    return <span>{TR.cm_playlist_is_empty}</span>;
  }, [performanceIds]);

  const editPerformanceDialog = () => {
    if (chosenPerformance) {
      return <EditPlayListPerformance
        open={isEditPerformanceOpen}
        onClose={handleCloseEditPerformance}
        performanceId={chosenPerformance.unique_id}
        performance={chosenPerformance}
        onEditPerformance={handleEditPerformance}
        pitch={chosenPerformance.pitch}
        track={chosenPerformance.track}
        playList={props.playList}
        singers={singers}
        singer={chosenPerformance.profile}
        isPlaying={isPlaying.isPlaying}
        playLists={playLists}
        playQueue={playQueue}
        isPlayingNow={isPlayingNow}
      />;
    }
  };

  const renderChangeTrackDialog = () => {
    if (performanceToBeChanged) {
      return <ChangeTrackPerformance
        open={isChangeTrackPerformanceOpen}
        onClose={handleCloseChangeTrackPerformance}
        track={chosenTrack}
        performance={performanceToBeChanged}
        onChangeTrackPerformance={handleChangeTrackPerformance}
        singers={singers}
      />;
    }
  };

  const secondaryText = () => {
    if (props.performances) {
      let date = new Date(props.created);
      date.setMinutes(date.getMinutes() - timeDiff);
      return dayjs(date).format('YYYY-MM-DD') + " (" + props.performances.length + " " + TR.cm_songs + ")";
    }
  };

  const renderPlayListItems = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        return <DragDropContext onDragEnd={handleDragEnd}>
          <Droppable droppableId={"droppable-" + props.playList.id}>
            {(provided, snapshot) => (
              <div {...provided.droppableProps} ref={provided.innerRef} >
                <List className="muvika-list-performances" component="div" disablePadding>
                  {performances}
                </List>
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>;
      }
    } else {
      return <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId={"droppable-" + props.playList.id}>
          {(provided, snapshot) => (
            <div {...provided.droppableProps} ref={provided.innerRef} >
              <List className="muvika-list-performances" component="div" disablePadding>
                {performances}
              </List>
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>;
    }
    return <List className="muvika-list-performances" component="div" disablePadding>
      {performancesNonDraggable}
    </List>;
  };

  return (
    <div>
      {editPerformanceDialog()}
      {renderChangeTrackDialog()}
      <ListItemButton onClick={handleClick}>
        <ListItemText primary={props.name} secondary={secondaryText()} />
        {buttons()}
        <IconButton onClick={handleClick}>
          {open ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {renderPlayListItems()}
      </Collapse>
    </div>
  );
}

export default PlayListListItem;